<template>
  <div class="stbox">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>感染监测数据上报</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs style="margin-top: 15px" v-model="activeName">
      <el-tab-pane label="数据上报" name="first">
        <div class="header"></div>
        <div class="content">
          <el-carousel trigger="click" height="150px" :autoplay="false" :loop="false" :initial-index="9">
            <el-carousel-item v-for="item in years" :key="item">
              <el-row :gutter="60">
                <el-col :span="4" v-for="i in ['01', '02', '03', '04', '05', '06']" :key="i">
                  <div class="grid-content bg-purple" :class="{ 'green-bg': year_Month.includes(item + '-' + i) }">
                    {{ item + "-" + i }}
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="60">
                <el-col :span="4" v-for="i in ['07', '08', '09', '10', '11', '12']" :key="i">
                  <div class="grid-content bg-purple" :class="{ 'green-bg': year_Month.includes(item + '-' + i) }">
                    {{ item + "-" + i }}
                  </div>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="text" style="margin-top: 100px">
          <label>请先从本地选择数据包，然后点击数据上传按钮提交。<label class="texthos">{{ loginUser.HospitalName }}(医疗机构代码:{{
            loginUser.HospitalNumber
              }})</label></label>
        </div>
        <div class="container">
          <div class="item" style="margin: 100px 0 0 100px;display: flex;">
            <el-image class="image" :src="src"></el-image>
            <div class="upload-position">
              <p class="alltext">
                上传：数据包文件，按月上报数据
                <br />
                数据包文件要求ZIP格式
                <br />
                <label style="color:red">数据包命名可按“医院编号-年月”防止重复</label>
                <!-- ，
              <label class="red">按月或按季度上报数据，一次最多上传三个月数据</label>
              <br />
              数据包文件要求ZIP格式，有密码并且数据完整，文件没有损坏。 -->
              </p>
              <el-upload accept=".zip" class="upload-demo" ref="upload" :action="uploadFileUrl + 'Upload/UploadFile'"
                :before-upload="beforeUpload" :on-success="uploadSuccess" :on-exceed="handleExceed"
                :file-list="fileList" :auto-upload="false" :multiple="false" :limit="1">
                <el-button slot="trigger" type="primary">选择文件</el-button>
                <el-button style="margin-left: 10px" type="success" :loading="load" @click="sjsc">数据上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
              </el-upload>
              <div slot="tip">压缩包含解压密码：
                <el-switch v-model="isPwd" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
              </div>
            </div>
          </div>
          <div class="item">
            <el-steps :space="300" :active="progress" finish-status="success" align-center>
              <el-step title="上传数据包" description="数据包文件要求ZIP格式且文件没有损坏"></el-step>
              <el-step title="数据正在入库" description="数据将在24小时内完成入库,请耐心等待"></el-step>
              <el-step title="数据入库完成" description="点击左上角“数据浏览”查看数据"></el-step>
            </el-steps>
            <div style="margin-left:180px;margin-top:50px">
              <el-date-picker style="margin-left: 10px" v-model="selectMonth" type="month" placeholder="请选择月份"
                format="yyyy-MM" value-format="yyyy-MM">
              </el-date-picker>
              <el-button style="margin-left: 10px" type="danger" icon="el-icon-delete" :loading="load2"
                @click="scsj">删除数据</el-button><br />
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-dialog title="提示" :visible.sync="inputPassWord" width="30%">
        <span><el-input type="text" size="small" v-model="passWord" placeholder="请输入解压密码"></el-input></span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="inputPassWord = false">取 消</el-button>
          <el-button size="small" type="primary" @click="submitUpload">确 定</el-button>
        </span>
      </el-dialog>
      <el-tab-pane label="数据浏览" name="third">
        <div style="display: flex" v-if="permission > 0">
          <el-select clearable filterable style="width: 20%" v-model="searchHospitalNumber" placeholder="请选择医院">
            <el-option v-for="item in hospitalData" :key="item.HospitalNumber" :label="item.HospitalName"
              :value="item.HospitalNumber">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-tabs v-model="activeName2" @tab-click="handleClick">
            <el-tab-pane label="患者记录" name="hzjl-hzjlform">
              <el-form :inline="true" :model="hzjlform" class="demo-form-inline">
                <el-form-item label="在院时间">
                  <el-date-picker v-model="hzjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="hzjlform.outCome" clearable placeholder="请选择转归情况">
                    <el-option label="治愈" value="治愈"></el-option>
                    <el-option label="好转" value="好转"></el-option>
                    <el-option label="其他" value="其他"></el-option>
                    <el-option label="未愈" value="未愈"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="hzjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('hzjl', 'hzjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('hzjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="Sex" label="性别"> </el-table-column>
                <el-table-column prop="birthDay" label="出生日期">
                </el-table-column>
                <el-table-column prop="Weight" label="体重"> </el-table-column>
                <el-table-column prop="inHospAt" label="入院时间">
                </el-table-column>
                <el-table-column prop="inDept" label="入院科室">
                </el-table-column>
                <el-table-column prop="outHospAt" label="出院时间">
                </el-table-column>
                <el-table-column prop="outDept" label="出院科室">
                </el-table-column>
                <el-table-column prop="outCome" label="转归情况">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="转科记录" name="zkjl-zkjlform">
              <el-form :inline="true" :model="zkjlform" class="demo-form-inline">
                <el-form-item label="转科时间">
                  <el-date-picker v-model="zkjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="zkjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('zkjl', 'zkjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('zkjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="deptId" label="转科科室编码">
                </el-table-column>
                <el-table-column prop="deptName" label="转入科室名称">
                </el-table-column>
                <el-table-column prop="inDeptAt" label="转入时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="感染记录" name="grjl-grjlform">
              <el-form :inline="true" :model="grjlform" class="demo-form-inline">
                <el-form-item label="感染时间">
                  <el-date-picker v-model="grjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="grjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="grjlform.infectType" clearable placeholder="请选择感染类型">
                    <el-option label="医院感染" value="1"></el-option>
                    <el-option label="社区感染" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="grjlform.infectName" filterable clearable placeholder="请选择感染部位">
                    <el-option v-for="item in grbw" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('grjl', 'grjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('grjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="infectId" label="感染部位编码">
                </el-table-column>
                <el-table-column prop="infectName" label="感染部位名称">
                </el-table-column>
                <el-table-column label="感染类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.infectType == '1'">医院感染</label>
                    <label v-if="scope.row.infectType == '2'">社区感染</label>
                  </template>
                </el-table-column>
                <el-table-column prop="infectDate" label="感染时间" width="170">
                </el-table-column>
                <el-table-column prop="conDate" label="确诊时间" width="170">
                </el-table-column>
                <el-table-column prop="reportDate" label="上报时间" width="170">
                </el-table-column>
                <el-table-column prop="deptName" label="感染标准科室">
                </el-table-column>
                <el-table-column prop="operId" label="手术单号">
                </el-table-column>
                <el-table-column prop="easyFactor" label="易感因素" width="200">
                </el-table-column>
                <el-table-column label="是否新生儿">
                  <template slot-scope="scope">
                    <label v-if="scope.row.IsXse == '1'">是</label>
                    <label v-else>否</label>
                  </template>
                </el-table-column>
                <el-table-column label="感染三管类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Grsglx == 'ZXJMZG'">中心静脉置管</label>
                    <label v-if="scope.row.Grsglx == 'MNDCG'">泌尿道插管</label>
                    <label v-if="scope.row.Grsglx == 'HXJ'">呼吸机</label>
                    <label v-if="scope.row.Grsglx == 'XTZXJMZG'">血透中心静脉置管</label>
                    <label v-if="scope.row.Grsglx == 'CVC'">血管导管包括中心静脉导管</label>
                    <label v-if="scope.row.Grsglx == 'PICC'">经外周置入中心静脉导管</label>
                    <label v-if="scope.row.Grsglx == 'PORT'">输液港</label>
                    <label v-if="scope.row.Grsglx == 'UVC'">脐静脉导管</label>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="送检记录" name="sjjl-sjjlform">
              <el-form :inline="true" :model="sjjlform" class="demo-form-inline">
                <el-form-item label="送检时间">
                  <el-date-picker v-model="sjjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="sjjlform.typeName" placeholder="请输入送检项目"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="sjjlform.itemName" placeholder="请输入送检标本"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="sjjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="sjjlform.testId" placeholder="请输入送检单号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('sjjl', 'sjjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('sjjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="testId" label="送检单号">
                </el-table-column>
                <el-table-column prop="typeName" label="检查项目名称">
                </el-table-column>
                <el-table-column prop="itemId" label="标本编号">
                </el-table-column>
                <el-table-column prop="itemName" label="标本名称">
                </el-table-column>
                <el-table-column prop="normName" label="标准标本名称">
                </el-table-column>
                <el-table-column prop="submitAt" label="送检时间">
                </el-table-column>
                <el-table-column prop="deptId" label="送检科室编号">
                </el-table-column>
                <el-table-column prop="typeId" label="检验项目类型编码">
                </el-table-column>
                <el-table-column prop="infectId" label="感染送检">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="微生物培养" name="wswpy-wswpyform">
              <el-form :inline="true" :model="wswpyform" class="demo-form-inline">
                <el-form-item label="检出时间">
                  <el-date-picker v-model="wswpyform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="wswpyform.zyh" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="wswpyform.pathoName" placeholder="请输入细菌名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="wswpyform.infectType" clearable placeholder="请选择感染类型">
                    <el-option label="医院感染" value="1"></el-option>
                    <el-option label="社区感染" value="2"></el-option>
                    <el-option label="定植" value="3"></el-option>
                    <el-option label="污染" value="4"></el-option>
                    <el-option label="其他" value="5"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search"
                    @click="searchData('wswpy', 'wswpyform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('wswpy')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="testId" label="送检单号">
                </el-table-column>
                <el-table-column prop="testAt" label="检出时间">
                </el-table-column>
                <el-table-column prop="pathoId" label="检出菌编号">
                </el-table-column>
                <el-table-column prop="pathoName" label="检出菌名称">
                </el-table-column>
                <el-table-column prop="normName" label="标准细菌名称">
                </el-table-column>
                <el-table-column prop="pathogenSn" label="检出结果编号">
                </el-table-column>
                <el-table-column label="感染类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.infectType == '1'">医院感染</label>
                    <label v-if="scope.row.infectType == '2'">社区感染</label>
                    <label v-if="scope.row.infectType == '3'">定植</label>
                    <label v-if="scope.row.infectType == '4'">污染</label>
                    <label v-if="scope.row.infectType == '5'">其他</label>
                  </template>
                </el-table-column>
                <el-table-column label="是否多重耐药">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Isdcny == '1'">是</label>
                    <label v-else>否</label>
                  </template>
                </el-table-column>
                <el-table-column label="多耐类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.NyType == 'MRSA'">耐甲氧西林金黄色葡萄球菌</label>
                    <label v-if="scope.row.NyType == 'VRE'">耐万古霉素肠球菌（仅指屎肠球菌、粪肠球菌）</label>
                    <label v-if="scope.row.NyType == 'CRKP'">耐碳青霉烯类肺炎克雷伯菌</label>
                    <label v-if="scope.row.NyType == 'CREC'">耐碳青霉烯类大肠埃希菌</label>
                    <label v-if="scope.row.NyType == 'CRPA'">耐碳青霉烯类铜绿假单胞菌</label>
                    <label v-if="scope.row.NyType == 'CRAB'">耐碳青霉烯类鲍曼不动杆菌</label>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="药敏结果" name="ymjg-ymjgform">
              <el-form :inline="true" :model="ymjgform" class="demo-form-inline">
                <el-form-item label="在院时间">
                  <el-date-picker v-model="ymjgform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="ymjgform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="ymjgform.antiName" placeholder="请输入药敏药物名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="ymjgform.micResult" clearable placeholder="请选择药敏结果">
                    <el-option label="敏感" value="S"></el-option>
                    <el-option label="耐药" value="R"></el-option>
                    <el-option label="中介" value="I"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('ymjg', 'ymjgform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('ymjg')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="testId" label="送检单号">
                </el-table-column>
                <el-table-column prop="resultDate" label="生成时间">
                </el-table-column>
                <el-table-column prop="antiId" label="药敏药物编号">
                </el-table-column>
                <el-table-column prop="antiName" label="药敏药物名称">
                </el-table-column>
                <el-table-column prop="normName" label="标准抗菌药物名称">
                </el-table-column>
                <el-table-column label="药敏结果">
                  <template slot-scope="scope">
                    <label v-if="scope.row.micResult == 'S'">敏感</label>
                    <label v-if="scope.row.micResult == 'R'">耐药</label>
                    <label v-if="scope.row.micResult == 'I'">中介</label>
                  </template>
                </el-table-column>
                <el-table-column prop="testResult" label="检验值">
                </el-table-column>
                <el-table-column prop="pathogenSn" label="检出菌编号">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="器械相关医嘱" name="qxxgyz-qxxgyzform">
              <el-form :inline="true" :model="qxxgyzform" class="demo-form-inline">
                <el-form-item label="开嘱时间">
                  <el-date-picker v-model="qxxgyzform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="qxxgyzform.zyId" placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="qxxgyzform.deptId" placeholder="请输入开嘱科室"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="qxxgyzform.intubation" clearable placeholder="请选择器械类型">
                    <el-option label="静脉插管" value="1"></el-option>
                    <el-option label="留置导尿管" value="2"></el-option>
                    <el-option label="使用有创呼吸机" value="3"></el-option>
                    <el-option label="隔离医嘱" value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search"
                    @click="searchData('qxxgyz', 'qxxgyzform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('qxxgyz')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="yzId" label="医嘱编号">
                </el-table-column>
                <el-table-column prop="orderAt" label="开嘱时间">
                </el-table-column>
                <el-table-column prop="stopAt" label="停嘱时间">
                </el-table-column>
                <el-table-column prop="orderName" label="医嘱名称">
                </el-table-column>
                <el-table-column prop="deptName" label="开嘱科室">
                </el-table-column>
                <el-table-column label="器械类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.intubation == '1'">静脉插管</label>
                    <label v-if="scope.row.intubation == '2'">留置导尿管</label>
                    <label v-if="scope.row.intubation == '3'">使用有创呼吸机</label>
                    <label v-if="scope.row.intubation == '4'">隔离医嘱</label>
                  </template>
                </el-table-column>
                <el-table-column label="三管类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Sglx == 'ZXJMZG'">中心静脉置管</label>
                    <label v-if="scope.row.Sglx == 'MNDCG'">泌尿道插管</label>
                    <label v-if="scope.row.Sglx == 'HXJ'">呼吸机</label>
                    <label v-if="scope.row.Sglx == 'XTZXJMZG'">血透中心静脉置管</label>
                    <label v-if="scope.row.Sglx == 'CVC'">血管导管包括中心静脉导管</label>
                    <label v-if="scope.row.Sglx == 'PICC'">经外周置入中心静脉导管</label>
                    <label v-if="scope.row.Sglx == 'PORT'">输液港</label>
                    <label v-if="scope.row.Sglx == 'UVC'">脐静脉导管</label>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="抗菌药物" name="kjyw-kjywform">
              <el-form :inline="true" :model="kjywform" class="demo-form-inline">
                <el-form-item label="在院时间">
                  <el-date-picker v-model="kjywform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="kjywform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="kjywform.usePurpose" clearable placeholder="请选择用药目的">
                    <el-option label="预防" value="1"></el-option>
                    <el-option label="治疗" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="kjywform.routeName" clearable placeholder="请选择给药途径">
                    <el-option label="全身用药" value="全身用药"></el-option>
                    <el-option label="局部用药" value="局部用药"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="kjywform.normName" filterable clearable placeholder="请选择药物">
                    <el-option v-for="item in kjyw" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('kjyw', 'kjywform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('kjyw')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="orderAt" label="开嘱时间" width="160">
                </el-table-column>
                <el-table-column prop="stopAt" label="停嘱时间" width="160">
                </el-table-column>
                <el-table-column prop="execAt" label="首次给药时间" width="160">
                </el-table-column>
                <el-table-column prop="lastAt" label="末次用药时间" width="160">
                </el-table-column>
                <el-table-column prop="orderId" label="抗菌药物编码" width="110">
                </el-table-column>
                <el-table-column prop="orderName" label="抗菌药物名称" width="160">
                </el-table-column>
                <el-table-column prop="normName" label="标准抗菌药物名称" width="160">
                </el-table-column>
                <el-table-column prop="deptName" label="开嘱科室">
                </el-table-column>
                <el-table-column prop="routeName" label="给药途径">
                </el-table-column>
                <el-table-column label="用药目的">
                  <template slot-scope="scope">
                    <lable v-if="scope.row.usePurpose == '1'">预防</lable>
                    <lable v-if="scope.row.usePurpose == '2'">治疗</lable>
                  </template>
                </el-table-column>
                <el-table-column prop="drugLine" label="级别">
                </el-table-column>
                <el-table-column label="是否重点用药" width="110">
                  <template slot-scope="scope">
                    <lable v-if="scope.row.IsZdyw == '1'">是</lable>
                    <lable v-else>否</lable>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="手术记录" name="ssjl-ssjlform">
              <el-form :inline="true" :model="ssjlform" class="demo-form-inline">
                <el-form-item label="手术时间">
                  <el-date-picker v-model="ssjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="ssjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input clearable v-model="ssjlform.operName" placeholder="请输入手术名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="ssjlform.operGrade" clearable placeholder="请选择切口等级">
                    <el-option label="零类切口" value="0"></el-option>
                    <el-option label="Ⅰ类切口" value="1"></el-option>
                    <el-option label="Ⅱ类切口" value="2"></el-option>
                    <el-option label="Ⅲ类切口" value="3"></el-option>
                    <el-option label="Ⅳ类切口" value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="ssjlform.Heal" clearable placeholder="请选择愈合情况">
                    <el-option label="甲类愈合" value="1"></el-option>
                    <el-option label="乙类愈合" value="2"></el-option>
                    <el-option label="丙类愈合" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('ssjl', 'ssjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('ssjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="orderId" label="手术单号">
                </el-table-column>
                <el-table-column prop="operId" label="手术编码">
                </el-table-column>
                <el-table-column prop="operName" label="手术名称">
                </el-table-column>
                <el-table-column prop="operGrade" label="切口等级">
                </el-table-column>
                <el-table-column label="愈合情况">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Heal == '1'">甲类愈合</label>
                    <label v-if="scope.row.Heal == '2'">乙类愈合</label>
                    <label v-if="scope.row.Heal == '3'">丙类愈合</label>
                  </template>
                </el-table-column>
                <el-table-column prop="Asa" label="麻醉评分"> </el-table-column>
                <el-table-column prop="startTime" label="手术开始时间" width="160">
                </el-table-column>
                <el-table-column prop="endTime" label="手术结束时间" width="160">
                </el-table-column>
                <el-table-column prop="deptName" label="手术申请科室">
                </el-table-column>
                <el-table-column label="是否感染">
                  <template slot-scope="scope">
                    <label v-if="scope.row.IsInfect == '1'">是</label>
                    <label v-else>否</label>
                  </template>
                </el-table-column>
                <el-table-column label="感染部位">
                  <template slot-scope="scope">
                    <label v-if="scope.row.SF_InfectDIag == '176'">表浅切口</label>
                    <label v-if="scope.row.SF_InfectDIag == '177'">深部切口</label>
                    <label v-if="scope.row.SF_InfectDIag == '178'">器官腔隙</label>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="诊断记录" name="zdjl-zdjlform">
              <el-form :inline="true" :model="zdjlform" class="demo-form-inline">
                <el-form-item label="诊断时间">
                  <el-date-picker v-model="zdjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="zdjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="zdjlform.digType" clearable placeholder="请选择诊断类型">
                    <el-option label="门/急诊" value="1"></el-option>
                    <el-option label="入院" value="2"></el-option>
                    <el-option label="出院" value="3"></el-option>
                    <el-option label="其他" value="4"></el-option>
                    <el-option label="病理" value="5"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('zdjl', 'zdjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('zdjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="digId" label="诊断编码">
                </el-table-column>
                <el-table-column prop="digName" label="诊断名称">
                </el-table-column>
                <el-table-column label="诊断类型">
                  <template slot-scope="scope">
                    <label v-if="scope.row.digType == '1'">门/急诊</label>
                    <label v-if="scope.row.digType == '2'">入院</label>
                    <label v-if="scope.row.digType == '3'">出院</label>
                    <label v-if="scope.row.digType == '4'">其它</label>
                    <label v-if="scope.row.digType == '5'">病理</label>
                  </template>
                </el-table-column>
                <el-table-column prop="digDate" label="诊断时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="体温记录" name="twjl-twjlform">
              <el-form :inline="true" :model="twjlform" class="demo-form-inline">
                <el-form-item label="记录时间">
                  <el-date-picker v-model="twjlform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="twjlform.zyId" clearable placeholder="请输入住院号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('twjl', 'twjlform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('twjl')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData" stripe style="width: 100%">
                <el-table-column prop="zyId" label="住院号"> </el-table-column>
                <el-table-column prop="tempValues" label="体温值">
                </el-table-column>
                <el-table-column prop="recodAt" label="记录时间">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="科室信息" name="ksxx-ksxxform">
              <el-form :inline="true" :model="ksxxform" class="demo-form-inline">
                <el-form-item>
                  <el-input clearable v-model="ksxxform.deptName" placeholder="请输入科室名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('ksxx', 'ksxxform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('ksxx')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData.slice(
                  (pageIndex - 1) * pageSize,
                  pageIndex * pageSize
                )
                  " stripe style="width: 100%">
                <el-table-column prop="deptId" label="科室编码">
                </el-table-column>
                <el-table-column prop="deptName" label="科室名称">
                </el-table-column>
                <el-table-column prop="normDept" label="标准科室名称">
                </el-table-column>
                <el-table-column label="是否ICU">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Icu == '1'">是</label>
                    <label v-if="scope.row.Icu == '0'">否</label>
                  </template>
                </el-table-column>
                <el-table-column label="是否新生儿">
                  <template slot-scope="scope">
                    <label v-if="scope.row.newborn == '1'">是</label>
                    <label v-if="scope.row.newborn == '0'">否</label>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="血透报表" name="xtbb-xtbbform">
              <el-form :inline="true" :model="xtbbform" class="demo-form-inline">
                <el-form-item label="日期">
                  <el-date-picker v-model="xtbbform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions"
                    value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData('xtbb', 'xtbbform')">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData('xtbb')">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)" :data="allData.slice(
                  (pageIndex - 1) * pageSize,
                  pageIndex * pageSize
                )
                  " stripe style="width: 100%">
                <el-table-column fixed="left" prop="日期" label="日期" width="200">
                </el-table-column>
                <el-table-column prop="新入透析人数" label="新入透析人数" width="130">
                </el-table-column>
                <el-table-column prop="当日透析人数" label="当月透析人数" width="130">
                </el-table-column>
                <el-table-column label="血管通路类型">
                  <el-table-column prop="内瘘例数" label="内瘘例数" width="100">
                  </el-table-column>
                  <el-table-column prop="人工血管例数" label="人工血管例数" width="130">
                  </el-table-column>
                  <el-table-column prop="隧道式中心导管例数" label="隧道式中心导管例数" width="150">
                  </el-table-column>
                  <el-table-column prop="非隧道式中心导管例数" label="非隧道式中心导管例数" width="180">
                  </el-table-column>
                </el-table-column>
                <el-table-column label="导管穿刺部位">
                  <el-table-column label="锁骨下静脉">
                    <el-table-column prop="锁骨下静脉_例数" label="例数" width="50">
                    </el-table-column>
                    <el-table-column prop="锁骨下静脉_发生感染例数" label="发生感染例数" width="130">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="颈内静脉">
                    <el-table-column prop="颈内静脉_例数" label="例数" width="50">
                    </el-table-column>
                    <el-table-column prop="颈内静脉_发生感染例数" label="发生感染例数" width="130">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="股静脉">
                    <el-table-column prop="股静脉_例数" label="例数" width="50">
                    </el-table-column>
                    <el-table-column prop="股静脉_发生感染例数" label="发生感染例数" width="130">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="其他">
                    <el-table-column prop="其他_例数" label="例数" width="50">
                    </el-table-column>
                    <el-table-column prop="其他_发生感染例数" label="发生感染例数" width="130">
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="血透事件">
                  <el-table-column prop="使用抗菌药物例数" label="使用抗菌药物例数" width="150">
                  </el-table-column>
                  <el-table-column prop="使用抗菌药物比率" label="使用抗菌药物比率" width="150">
                  </el-table-column>
                  <el-table-column prop="血培养阳性例数" label="血培养阳性例数" width="150">
                  </el-table-column>
                  <el-table-column prop="血培养阳性比率" label="血培养阳性比率" width="150">
                  </el-table-column>
                  <el-table-column prop="血管通路部位出现脓液_发红或肿胀加剧例数" label="血管通路部位出现脓液、发红或肿胀加剧例数" width="200">
                  </el-table-column>
                  <el-table-column prop="血管通路部位出现脓液_发红或肿胀加剧比率" label="血管通路部位出现脓液、发红或肿胀加剧比率" width="200">
                  </el-table-column>
                </el-table-column>
                <el-table-column prop="血流感染例次数" label="血流感染例次数" width="150">
                </el-table-column>
                <el-table-column prop="血流感染比率" label="血流感染比率" width="150">
                </el-table-column>
                <el-table-column prop="血管通路相关血流感染例次数" label="血管通路相关血流感染例次数" width="220">
                </el-table-column>
                <el-table-column prop="血管通路相关血流感染比率" label="血管通路相关血流感染比率" width="200">
                </el-table-column>
                <el-table-column prop="血管通路感染例次数" label="血管通路感染例次数" width="200">
                </el-table-column>
                <el-table-column prop="血管通路感染例次数比率" label="血管通路感染例次数比率" width="200">
                </el-table-column>
                <el-table-column prop="血管导管相关血流感染例次数" label="血管导管相关血流感染例次数" width="220">
                </el-table-column>
                <el-table-column prop="原有HBV例数" label="原有HBV例数" width="150">
                </el-table-column>
                <el-table-column prop="原有HCV例数" label="原有HCV例数" width="150">
                </el-table-column>
                <el-table-column prop="原有HIV例数" label="原有HIV例数" width="150">
                </el-table-column>
                <el-table-column prop="原有梅毒例数" label="原有梅毒例数" width="150">
                </el-table-column>
                <el-table-column prop="透析中新增HBV例数" label="透析中新增HBV例数" width="150">
                </el-table-column>
                <el-table-column prop="透析中新增HCV例数" label="透析中新增HCV例数" width="150">
                </el-table-column>
                <el-table-column prop="透析中新增HIV例数" label="透析中新增HIV例数" width="150">
                </el-table-column>
                <el-table-column prop="透析中新增梅毒例数" label="透析中新增梅毒例数" width="150">
                </el-table-column>
                <el-table-column prop="其他医院感染" label="其他医院感染" width="150">
                </el-table-column>
                <el-table-column prop="血液透析相关感染发生率" label="血液透析相关感染发生率" width="200">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <div class="block">
              <el-pagination :current-page="pageIndex" :page-size="pageSize" layout="prev, pager, next, jumper"
                :total="allCount || allData.length" @current-change="currentPage" />
            </div>
          </el-tabs>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/ecmascript-6">
import FileSaver from "file-saver"
import * as XLSX from "xlsx"
import { getHospital, getHospital2, updateProgress, deleteDataByMonth } from "../../api/hospital"
import { unZipToFile, readFiles } from "../../api/upload"
import {
  getMedicine,
  getInfectionPosition,
  getYear_Month,
  getPatientInfo,
  getChangekeshi,
  getInfectedInfo,
  getInspectionInfo,
  getMicroorganism,
  getDrugsensitivity,
  getApparatus,
  getAntibiotics,
  getOperation,
  getDiagnosis,
  getTemperature,
  getDicDept,
  getHemodialysis,
  getStatement,
  get_00_packinfo,
  getExportPatientInfo,
  getExportChangekeshi,
  getExportInfectedInfo,
  getExportInspectionInfo,
  getExportMicroorganism,
  getExportDrugsensitivity,
  getExportApparatus,
  getExportAntibiotics,
  getExportOperation,
  getExportDiagnosis,
  getExportTemperature,
  getExportStatement
} from "../../api/search"
export default {
  name: "welcome",
  data() {
    return {
      progress: 0,
      grbw: [],
      kjyw: [],
      pageIndex: 1,
      pageSize: 10,
      searchParams1: '',
      searchParams2: '',
      load: false,
      load2: false,
      uploadFileUrl: "",
      activeName: "first",
      activeName2: "hzjl-hzjlform",
      loginUser: {},
      src: "../static/zip.png",
      fileList: [],
      hospitalData: [],
      hospitalNumber: "",
      hospitalName: "",
      searchHospitalNumber: "",
      allData: [],
      allCount: 0,
      year_Month: [],
      years: [],
      loading: true,
      hzjlform: {
        kssj: "",
        jssj: "",
        outCome: "",
        zyId: "",
        yydm: "",
        cmiissSn: "",
      },
      zkjlform: {
        kssj: "",
        jssj: "",
        zyId: "",
        yydm: "",
        cmiissSn: "",
      },
      grjlform: {
        kssj: "",
        jssj: "",
        zyId: "",
        infectType: "",
        infectName: "",
        yydm: "",
        cmiissSn: "",
      },
      sjjlform: {
        kssj: "",
        jssj: "",
        typeName: "",
        itemName: "",
        zyId: "",
        testId: "",
        infectId: "",
        yydm: "",
        cmiissSn: "",
      },
      wswpyform: {
        kssj: "",
        jssj: "",
        zyId: "",
        pathoName: "",
        infectType: "",
        yydm: "",
        cmiissSn: "",
      },
      ymjgform: {
        kssj: "",
        jssj: "",
        zyId: "",
        antiName: "",
        micResult: "",
        yydm: "",
        cmiissSn: "",
      },
      qxxgyzform: {
        kssj: "",
        jssj: "",
        zyId: "",
        deptId: "",
        intubation: "",
        yydm: "",
        cmiissSn: "",
      },
      kjywform: {
        kssj: "",
        jssj: "",
        zyId: "",
        routeName: "",
        usePurpose: "",
        normName: "",
        yydm: "",
        cmiissSn: "",
      },
      ssjlform: {
        kssj: "",
        jssj: "",
        zyId: "",
        operName: "",
        operGrade: "",
        Heal: "",
        yydm: "",
        cmiissSn: "",
      },
      zdjlform: {
        kssj: "",
        jssj: "",
        zyId: "",
        digType: "",
        yydm: "",
        cmiissSn: "",
      },
      twjlform: {
        kssj: "",
        jssj: "",
        zyId: "",
        yydm: "",
        cmiissSn: "",
      },
      ksxxform: {
        deptName: "",
        yydm: "",
        cmiissSn: "",
      },
      xtjlform: {
        kssj: "",
        jssj: "",
        zyId: "",
        yydm: "",
        cmiissSn: "",
      },
      xtbbform: {
        kssj: "",
        jssj: "",
        yydm: "",
        cmiissSn: "",
      },
      kssj: "",
      jssj: "",
      urlMap: {
        hzjl: getPatientInfo,
        zkjl: getChangekeshi,
        grjl: getInfectedInfo,
        sjjl: getInspectionInfo,
        wswpy: getMicroorganism,
        ymjg: getDrugsensitivity,
        qxxgyz: getApparatus,
        kjyw: getAntibiotics,
        ssjl: getOperation,
        zdjl: getDiagnosis,
        twjl: getTemperature,
        ksxx: getDicDept,
        xtjl: getHemodialysis,
        xtbb: getStatement,
      },
      selectMonth: '',
      inputPassWord: false,
      isPwd: true,
      passWord: "",
      permission: 0,
      searchForm: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()])
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date()
              const start = new Date(new Date().getFullYear(), 0)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 6)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      },
    }
  },
  components: {},
  created() {
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0]
    this.hospitalName = this.loginUser.HospitalName
    this.hospitalNumber = this.loginUser.HospitalNumber
    this.permission = this.loginUser.permission;
    this.uploadFileUrl = sessionStorage.getItem("baseURL")
  },
  mounted() {
    this.init()
    this.getHospitalData()
    this.searchData("hzjl", "hzjlform")
  },
  methods: {
    scsj() {
      if (!this.selectMonth) {
        this.$message.warning("月份不能为空,请选择对应月份")
        return
      } else {
        this.load2 = true
        this.$confirm("数据删除后不可恢复，是否确认", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteDataByMonth({
              month: this.selectMonth,
              yydm: this.hospitalNumber
            }).then((res) => {
              this.load2 = false
              this.$message.success(res.msg)
              this.init()
              this.getHospitalData()
              this.searchData("hzjl", "hzjlform")
            })
          })
          .catch(() => {
            this.load2 = false
            this.$message({
              type: "info",
              message: "已取消",
            })
          })
      }
    },
    sjsc() {
      if (this.isPwd) {
        this.inputPassWord = true
      } else {
        this.inputPassWord = false
        this.submitUpload()
      }
    },
    currentPage(page) {
      this.pageIndex = page
      this.searchData(this.searchParams1, this.searchParams2)
    },
    handleClick(tab) {
      this.pageIndex = 1
      if (this.kssj != "" && this.jssj != "") {
        const rspForm = this[tab.name.split("-")[1]]
        rspForm.page = this.pageIndex
        rspForm.ksjssj = []
        rspForm.ksjssj[0] = this.kssj
        rspForm.ksjssj[1] =
          this.jssj.split("-")[0] + "-" + this.jssj.split("-")[1]
        this.searchParams1 = tab.name.split("-")[0]
        this.searchParams2 = tab.name.split("-")[1]
        this.searchData(tab.name.split("-")[0], tab.name.split("-")[1])
      } else {
        this.searchParams1 = tab.name.split("-")[0]
        this.searchParams2 = tab.name.split("-")[1]
        this.searchData(tab.name.split("-")[0], tab.name.split("-")[1])
      }
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1)
      const whiteList = ["zip"]
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.warning("只能上传zip文件")
        return false
      }
    },
    submitUpload() {
      if (this.passWord == "" && this.isPwd) {
        this.$message.warning("请输入解压密码")
        return
      }
      if (!this.$refs.upload.uploadFiles.length) {
        this.$message.warning("请选择文件")
        this.load = false
        return
      }
      this.inputPassWord = false
      this.$refs.upload.submit()
      this.load = true
    },
    uploadSuccess(response) {
      updateProgress({
        hospitalNumber: this.hospitalNumber,
        progress: 1
      }).then((res1) => {
        if (res1.data < 1) {
          this.$alert('网络错误', '提示', {
            confirmButtonText: '确定',
          })
          return
        }
        this.progress = 1
        unZipToFile({
          zipPath: response.zipPath,
          unZipPath: response.unZipPath,
          passWord: this.passWord,
        }).then((res) => {
          if (res.status === "ok") {
            updateProgress({
              hospitalNumber: this.hospitalNumber,
              progress: 2
            }).then((res2) => {
              if (res2.data < 1) {
                this.$alert('网络错误', '提示', {
                  confirmButtonText: '确定',
                })
                return
              }
              this.progress = 2
              readFiles({
                unZipPath: response.unZipPath,
                hCode: this.hospitalNumber,
                hName: this.hospitalName,
              }).then((res) => {
                if (res.status === "ok") {
                  this.progress = 3
                  this.$alert(res.msg, '提示', {
                    confirmButtonText: '确定',
                  })
                  // this.$message.success(res.msg)
                  this.$refs.upload.clearFiles()
                  this.searchData("hzjl", "hzjlform")
                  this.load = false
                  this.getHospitalData()
                } else {
                  this.$alert(res.msg, '提示', {
                    confirmButtonText: '确定',
                  })
                  updateProgress({
                    hospitalNumber: this.hospitalNumber,
                    progress: 0
                  }).then((res4) => {
                    if (res4.data < 1) {
                      this.$alert('网络错误', '提示', {
                        confirmButtonText: '确定',
                      })
                      return
                    }
                    this.progress = 0
                  })
                  this.$refs.upload.clearFiles()
                  this.load = false
                }
              })
            })
          } else {
            this.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
            })
            updateProgress({
              hospitalNumber: this.hospitalNumber,
              progress: 0
            }).then((res) => {
              if (res.data < 1) {
                this.$alert('网络错误', '提示', {
                  confirmButtonText: '确定',
                })
                return
              }
              this.progress = 0
            })
            this.$refs.upload.clearFiles()
            this.load = false
          }
        })
      })
    },
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`
      )
    },
    searchData(name, form) {
      this.searchParams1 = name
      this.searchParams2 = form
      this.loading = true
      const rspForm = this[form]
      if (rspForm["ksjssj"] === undefined) {
        //rspForm['ksjssj'] = [this.getCurrentDateYYYYMM(),this.getCurrentDateYYYYMM()]
        this.$set(this[form], "ksjssj", [
          this.getCurrentDateYYYYMM(),
          this.getCurrentDateYYYYMM(),
        ])
      }
      if (name !== "ksxx") {
        rspForm["kssj"] = rspForm["ksjssj"][0]
        rspForm["jssj"] = rspForm["ksjssj"][1]
      }
      rspForm["jssj"] =
        rspForm["jssj"] + "-" + this.getCountDays(rspForm["jssj"])
      rspForm["yydm"] = this.hospitalNumber
      if (this.searchHospitalNumber != "") {
        rspForm["yydm"] = this.searchHospitalNumber
      }
      if (form != "ksxxform") {
        this.kssj = rspForm["kssj"]
        this.jssj = rspForm["jssj"]
      }
      rspForm.page = this.pageIndex
      this.searchForm = rspForm
      this.urlMap[name](rspForm).then((res) => {
        this.loading = false
        this.allData = res.data
        this.allCount = res.count
      })
    },
    exportData(type) {
      let headers = {}
      switch (type) {
        case "hzjl":
          // "患者记录.xlsx"
          headers = {
            zyId: '住院号',
            Sex: '性别',
            birthDay: '出生日期',
            Weight: '体重',
            inHospAt: '入院时间',
            inDept: '入院科室',
            outHospAt: '出院时间',
            outDept: '出院科室',
            outCome: '转规情况'
          }
          getExportPatientInfo(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '患者记录')
          })
          break
        case "zkjl":
          // "转科记录.xlsx"
          headers = {
            zyId: '住院号',
            deptId: '转科科室编码',
            deptName: '转入科室名称',
            inDeptAt: '转入时间'
          }
          getExportChangekeshi(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '转科记录')
          })
          break
        case "grjl":
          // "感染记录.xlsx"
          headers = {
            zyId: '住院号',
            infectId: '感染部位编码',
            infectName: '感染部位名称',
            infectType: '感染类型',
            infectDate: '感染时间',
            conDate: '确诊时间',
            reportDate: '上报时间',
            deptName: '感染标准科室',
            operId: '手术单号',
            easyFactor: '易感因素'
          }
          getExportInfectedInfo(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '感染记录')
          })
          break
        case "sjjl":
          // "送检记录.xlsx"
          headers = {
            zyId: '住院号',
            testId: '送检单号',
            typeName: '检查项目名称',
            itemId: '标本编号',
            itemName: '标本名称',
            normName: '标准标本名称',
            submitAt: '送检时间',
            deptId: '送检科室编号',
            typeId: '检验项目类型编码',
            infectId: '感染送检'
          }
          getExportInspectionInfo(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '送检记录')
          })
          break
        case "wswpy":
          // "微生物培养.xlsx"
          headers = {
            zyId: '住院号',
            testId: '送检单号',
            testAt: '检出时间',
            pathoId: '检出菌编号',
            pathoName: '检出菌名称',
            normName: '标准细菌名称',
            pathogenSn: '检出结果编号',
            infectType: '感染类型',
            Isdcny: '是否多重耐药',
            NyType: '多耐类型'
          }
          getExportMicroorganism(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '微生物培养')
          })
          break
        case "ymjg":
          // "药敏结果.xlsx"
          headers = {
            zyId: '住院号',
            testId: '送检单号',
            resultDate: '生成时间',
            antiId: '药敏药物编号',
            antiName: '药敏药物名称',
            normName: '标准抗菌药物名称',
            micResult: '药敏结果',
            testResult: '检验值',
            pathogenSn: '检出菌编号'
          }
          getExportDrugsensitivity(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '药敏结果')
          })
          break
        case "qxxgyz":
          // "器械相关医嘱.xlsx"
          headers = {
            zyId: '住院号',
            yzId: '医嘱编号',
            orderAt: '开嘱时间',
            stopAt: '停嘱时间',
            orderName: '医嘱名称',
            deptName: '开嘱科室',
            intubation: '器械类型',
            Sglx: '三管类型'
          }
          getExportApparatus(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '器械相关医嘱')
          })
          break
        case "kjyw":
          // "抗菌药物.xlsx"
          headers = {
            zyId: '住院号',
            orderAt: '开嘱时间',
            stopAt: '停嘱时间',
            execAt: '首次给药时间',
            lastAt: '末次用药时间',
            orderId: '抗菌药物编码',
            orderName: '抗菌药物名称',
            normName: '标准抗菌药物名称',
            deptName: '开嘱科室',
            routeName: '给药途径',
            usePurpose: '用药目的',
            drugLine: '级别',
            IsZdyw: '是否重点用药'
          }
          getExportAntibiotics(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '抗菌药物')
          })
          break
        case "ssjl":
          // "手术记录.xlsx"
          headers = {
            zyId: '住院号',
            orderId: '手术单号',
            operId: '手术编码',
            operName: '手术名称',
            operGrade: '切口等级',
            Heal: '愈合情况',
            Asa: '麻醉评分',
            startTime: '手术开始时间',
            endTime: '手术结束时间',
            deptName: '手术申请科室',
            IsInfect: '是否感染',
            SF_InfectDIag: '感染部位'
          }
          getExportOperation(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '手术记录')
          })
          break
        case "zdjl":
          // "诊断记录.xlsx"
          headers = {
            zyId: '住院号',
            digId: '诊断编码',
            digName: '诊断名称',
            digType: '诊断类型',
            digDate: '诊断时间'
          }
          getExportDiagnosis(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '诊断记录')
          })
          break
        case "twjl":
          // "体温记录.xlsx"
          headers = {
            zyId: '住院号',
            recodAt: '记录时间',
            tempValues: '体温值'
          }
          getExportTemperature(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '体温记录')
          })
          break
        case "ksxx":
          // "科室信息.xlsx"
          headers = {
            deptId: '科室编码',
            deptName: '科室名称',
            normDept: '标准科室名称',
            Icu: '是否ICU',
            newborn: '是否新生儿'
          }
          getDicDept({
            deptName: this.ksxxform.deptName,
            yydm: this.hospitalNumber,
            cmiissSn: ''
          }).then((res) => {
            this.toExcel(res.data, headers, '科室信息')
          })
          break
        case "xtjl":
          // "血透记录.xlsx"
          break
        case "xtbb":
          // "血透报表.xlsx"
          headers = {
            日期: '日期',
            新入透析人数: '新入透析人数',
            当日透析人数: '当月透析人数',
            内瘘例数: '内瘘例数',
            人工血管例数: '人工血管例数',
            锁骨下静脉_例数: '例数',
            锁骨下静脉_发生感染例数: '发生感染例数',
            颈内静脉_例数: '例数',
            颈内静脉_发生感染例数: '发生感染例数',
            股静脉_例数: '例数',
            股静脉_发生感染例数: '发生感染例数',
            其他_例数: '例数',
            其他_发生感染例数: '发生感染例数',
            使用抗菌药物例数: '使用抗菌药物例数',
            使用抗菌药物比率: '使用抗菌药物比率',
            血培养阳性例数: '血培养阳性例数',
            血培养阳性比率: '血培养阳性比率',
            血管通路部位出现脓液_发红或肿胀加剧例数: '血管通路部位出现脓液、发红或肿胀加剧例数',
            血管通路部位出现脓液_发红或肿胀加剧比率: '血管通路部位出现脓液、发红或肿胀加剧比率',
            血流感染例次数: '血流感染例次数',
            血流感染比率: '血流感染比率',
            血管通路相关血流感染例次数: '血管通路相关血流感染例次数',
            血管通路相关血流感染比率: '血管通路相关血流感染比率',
            血管通路感染例次数: '血管通路感染例次数',
            血管通路感染例次数比率: '血管通路感染例次数比率',
            血管导管相关血流感染例次数: '血管导管相关血流感染例次数',
            原有HBV例数: '原有HBV例数',
            原有HCV例数: '原有HCV例数',
            原有HIV例数: '原有HIV例数',
            原有梅毒例数: '原有梅毒例数',
            透析中新增HBV例数: '透析中新增HBV例数',
            透析中新增HCV例数: '透析中新增HCV例数',
            透析中新增HIV例数: '透析中新增HIV例数',
            透析中新增梅毒例数: '透析中新增梅毒例数',
            其他医院感染: '其他医院感染',
            血液透析相关感染发生率: '血液透析相关感染发生率'
          }
          getExportStatement(this.searchForm).then((res) => {
            this.toExcel(res.data, headers, '血透报表')
          })
          break
      }
    },
    toExcel(data, headers, fileName) {
      const headerKeys = Object.keys(headers)
      const headerValues = Object.values(headers)

      const worksheetData = [
        headerValues,
        ...data.map(row =>
          headerKeys.map(key => row[key] || '')
        )
      ]
      if (fileName == '感染记录') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][3] == '1') {
            worksheetData[i][3] = '医院感染'
          } else {
            worksheetData[i][3] = '社区感染'
          }
        }
      }
      if (fileName == '微生物培养') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][7] == '1') {
            worksheetData[i][7] = '医院感染'
          } else if (worksheetData[i][7] == '2') {
            worksheetData[i][7] = '社区感染'
          } else if (worksheetData[i][7] == '3') {
            worksheetData[i][7] = '定植'
          } else if (worksheetData[i][7] == '4') {
            worksheetData[i][7] = '污染'
          } else if (worksheetData[i][7] == '5') {
            worksheetData[i][7] = '其他'
          }
          if (worksheetData[i][8] == '1') {
            worksheetData[i][8] = '是'
          } else {
            worksheetData[i][8] = '否'
          }
          if (worksheetData[i][9] == 'MRSA') {
            worksheetData[i][9] = '耐甲氧西林金黄色葡萄球菌'
          } else if (worksheetData[i][9] == 'VRE') {
            worksheetData[i][9] = '耐万古霉素肠球菌（仅指屎肠球菌、粪肠球菌）'
          } else if (worksheetData[i][9] == 'CRKP') {
            worksheetData[i][9] = '耐碳青霉烯类肺炎克雷伯菌'
          } else if (worksheetData[i][9] == 'CREC') {
            worksheetData[i][9] = '耐碳青霉烯类大肠埃希菌'
          } else if (worksheetData[i][9] == 'CRPA') {
            worksheetData[i][9] = '耐碳青霉烯类铜绿假单胞菌'
          } else if (worksheetData[i][9] == 'CRAB') {
            worksheetData[i][9] = '耐碳青霉烯类鲍曼不动杆菌'
          }
        }
      }
      if (fileName == '药敏结果') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][6] == 'S') {
            worksheetData[i][6] = '敏感'
          } else if (worksheetData[i][6] == 'R') {
            worksheetData[i][6] = '耐药'
          } else if (worksheetData[i][6] == 'I') {
            worksheetData[i][6] = '中介'
          } else if (worksheetData[i][6] == '+') {
            worksheetData[i][6] = '阳性'
          } else if (worksheetData[i][6] == '-') {
            worksheetData[i][6] = '阴性'
          }
        }
      }
      if (fileName == '器械相关医嘱') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][6] == '1') {
            worksheetData[i][6] = '中心静脉插管'
          } else if (worksheetData[i][6] == '2') {
            worksheetData[i][6] = '导尿管插管'
          } else if (worksheetData[i][6] == '3') {
            worksheetData[i][6] = '呼吸机'
          } else if (worksheetData[i][6] == '4') {
            worksheetData[i][6] = '隔离医嘱'
          }
          if (worksheetData[i][7] == 'ZXJMZG') {
            worksheetData[i][7] = '中心静脉置管'
          } else if (worksheetData[i][7] == 'MNDCG') {
            worksheetData[i][7] = '泌尿道插管'
          } else if (worksheetData[i][7] == 'HXJ') {
            worksheetData[i][7] = '呼吸机'
          } else if (worksheetData[i][7] == 'XTZXJMZG') {
            worksheetData[i][7] = '血透中心静脉置管'
          } else if (worksheetData[i][7] == 'CVC') {
            worksheetData[i][7] = '血管导管包括中心静脉导管'
          } else if (worksheetData[i][7] == 'PICC') {
            worksheetData[i][7] = '经外周置入中心静脉导管'
          } else if (worksheetData[i][7] == 'PORT') {
            worksheetData[i][7] = '输液港'
          } else if (worksheetData[i][7] == 'UVC') {
            worksheetData[i][7] = '脐静脉导管'
          }
        }
      }
      if (fileName == '抗菌药物') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][10] == '1') {
            worksheetData[i][10] = '预防'
          } else if (worksheetData[i][10] == '2') {
            worksheetData[i][10] = '治疗'
          }
          if (worksheetData[i][11] == '1') {
            worksheetData[i][11] = '非限制'
          } else if (worksheetData[i][11] == '2') {
            worksheetData[i][11] = '限制'
          } else if (worksheetData[i][11] == '3') {
            worksheetData[i][11] = '特殊'
          }
          if (worksheetData[i][12] == '1') {
            worksheetData[i][12] = '是'
          } else if (worksheetData[i][12] == '0') {
            worksheetData[i][12] = '否'
          }
        }
      }
      if (fileName == '手术记录') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][5] == '1') {
            worksheetData[i][5] = '甲类愈合'
          } else if (worksheetData[i][5] == '2') {
            worksheetData[i][5] = '乙类愈合'
          } else if (worksheetData[i][5] == '3') {
            worksheetData[i][5] = '丙类愈合'
          }
          if (worksheetData[i][10] == '1') {
            worksheetData[i][10] = '是'
          } else if (worksheetData[i][10] == '0') {
            worksheetData[i][10] = '否'
          }
          if (worksheetData[i][11] == '176') {
            worksheetData[i][11] = '表浅切口'
          } else if (worksheetData[i][11] == '177') {
            worksheetData[i][11] = '深部切口'
          } else if (worksheetData[i][11] == '178') {
            worksheetData[i][11] = '器官腔隙'
          }
        }
      }
      if (fileName == '诊断记录') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][3] == '1') {
            worksheetData[i][3] = '门/急诊'
          } else if (worksheetData[i][3] == '2') {
            worksheetData[i][3] = '入院'
          } else if (worksheetData[i][3] == '3') {
            worksheetData[i][3] = '出院'
          } else if (worksheetData[i][3] == '4') {
            worksheetData[i][3] = '其它'
          } else if (worksheetData[i][3] == '5') {
            worksheetData[i][3] = '病理'
          }
        }
      }
      if (fileName == '科室信息') {
        for (let i = 1; i < worksheetData.length; i++) {
          if (worksheetData[i][3] == '1') {
            worksheetData[i][3] = '是'
          } else if (worksheetData[i][3] == '0') {
            worksheetData[i][3] = '否'
          }
          if (worksheetData[i][4] == '1') {
            worksheetData[i][4] = '是'
          } else if (worksheetData[i][4] == '0') {
            worksheetData[i][4] = '否'
          }
        }
      }

      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, fileName)

      XLSX.writeFile(workbook, fileName + `.xlsx`)
    },
    init() {
      let nowYear = new Date().getFullYear()
      for (let i = 0; i < 10; i++) {
        this.years.push(nowYear--)
      }
      this.years.reverse()
    },
    //获取医院
    getHospitalData() {
      getMedicine().then((res) => {
        this.kjyw = res.data
      })
      getInfectionPosition().then((res) => {
        this.grbw = res.data
      })
      getYear_Month({ hospitalCode: this.hospitalNumber }).then((res) => {
        this.year_Month = res.data
      })
      getHospital({ hospitalName: "" }).then((res) => {
        this.hospitalData = []
        for (let i = 0; i < res.data.length; i++) {
          if (this.permission == 1) {
            this.hospitalData = res.data;
          } else if (this.permission == 2) {
            if (res.data[i].Area.split(',')[1] == this.loginUser.Area.split(',')[1]) {
              this.hospitalData.push(res.data[i])
            }
          } else if (this.permission == 3) {
            if (res.data[i].Area.split(',')[2] == this.loginUser.Area.split(',')[2]) {
              this.hospitalData.push(res.data[i])
            }
          }
        }
      })
      getHospital2({ hospitalName: this.hospitalName }).then((res) => {
        this.progress = res.data[0].progress
        if (res.data[0].progress == '2') {
          this.load = true
        }
      })
    },
    getCurrentDateYYYYMM() {
      const now = new Date()
      const year = now.getFullYear()
      let month = now.getMonth() + 1
      month = month.toString().padStart(2, "0")
      return `${year}-${month}`
    },
    getCountDays(curDate) {
      const d = new Date(curDate)
      const y = d.getFullYear()
      //获取本月的下一个月
      const m = d.getMonth() + 1
      // 下一个月的第0天就是这个月的天数
      const days = new Date(y, m, 0).getDate()
      return days
    },
  },
}
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.header {
  margin-top: 15px;
}

.header .first {
  margin-top: 30px;
  font-size: 14px;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.green {
  color: green;
}

.content {
  width: 90%;
  margin: 50px 5%;
}

.bottom {
  margin: 100px 0 0 100px;
  display: flex;
}

.image {
  height: 200px;
}

.upload-demo {
  margin: 90px 0 0 0;
}

.alltext {
  font-size: 14px;
}

.text {
  font-size: 14px;
}

.texthos {
  color: black;
}

.btnClass {
  height: 40px;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background-color: #ffa8a8;
  color: red;
}

.bg-purple {
  background-color: #ffa8a8;
  color: red;
}

.bg-purple-light {
  background-color: #ffa8a8;
  color: red;
}

.grid-content {
  border-radius: 4px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #ffa8a8;
  color: red;
}

.green-bg {
  background-color: #67c23a;
  color: #ffffff;
}

.select {
  width: 20%;
}

.container {
  display: flex;
  /* 可选：控制间距 */
  gap: 10px;
}

.item {
  /* 可选：设置 flex 属性 */
  flex: 1;
  /* 平均分配空间 */
  /* 或者设置固定宽度 */
  /* width: 200px; */
}

/* background-color: #ffcc99;
    color: #ff6600; */
</style>



// WEBPACK FOOTER //
// src/views/machine/Machine.vue